import { State } from "@meraki-internal/state";
import { IEvent, IFundingCampaign, ISponsor, ITestimonial, IVolunteer, IWebsiteClub, IWebsiteDataV3 } from "./IWebsiteDataV3";
import { ClubsState, IVolunteerMediaType } from "./clubs/ClubsState";

export class WebsiteDataV3 implements IWebsiteDataV3 {
    constructor() {
        throw new Error('should not instantiate');
    }
    volunteers: IVolunteer[];
    clubs: IWebsiteClub[];
    events: IEvent[];
    testimonials: ITestimonial[];
    campaigns: IFundingCampaign[];
    sponsors: ISponsor[];
}

export interface ICompetingOrFutureClub extends IWebsiteClub {
    status: 'status-forming' | 'status-competing';
}

// TODO: is this needed anymore?
export interface VolunteerForUI {
    volunteerId: string;
    clubIds: string[];
    name: string;
    imagePath: string;
    titles: string[];
}

// TODO: get this to its own file
export class DataModelV2 extends State<Record<string, never>> {
    static inject = () => [
        WebsiteDataV3,
        ClubsState
    ];
    constructor(
        private data: WebsiteDataV3,
        private clubsState: ClubsState
    ) {
        super({});

        this.clubsState.subscribe(() => {
            this.setState({});
        });
    }

    getAllEvents = (): IEvent[] => {
        return [
            {
                "eventId": "black-hills-robo-rally-2025",
                "name": "Black Hills Robo Rally",
                "imagePath": "images/push-back/push-back-2.jpg",
                "date": "Sep 13, 2025",
                "description": "Fun Competition open to all 5th through 12 graders interested in learning more about competitive robotics in the Black Hills area.",
                "location": "Spearfish Middle School",
                "url": "https://givebutter.com/SX4wbx",
            },
            {
                "eventId": "douglas-2025",
                "name": "Box Elder Bot Bonanza",
                "imagePath": "images/push-back/push-back-1.png",
                "date": "Oct 25, 2025",
                "description": "Blended MS/HS VEX V5 Robotics Competition (NO JUDGING)",
                "location": "Douglas High School",
                "url": "https://www.robotevents.com/robot-competitions/vex-robotics-competition/RE-V5RC-25-0610.html#general-info",
            },
            {
                "eventId": "harrisburg-2025",
                "name": "Tiger Nation Elevated Experience",
                "imagePath": "images/push-back/push-back-2.jpg",
                "date": "Nov 22, 2025",
                "description": "Blended MS/HS VEX V5 Robotics Competition (NO JUDGING)",
                "location": "Harrisburg South Middle School",
                "url": "https://www.robotevents.com/robot-competitions/vex-robotics-competition/RE-V5RC-25-0630.html#general-info",
            },
            {
                "eventId": "dsu-2025",
                "name": "Dakota State University",
                "imagePath": "images/push-back/push-back-1.png",
                "date": "Dec 20, 2025",
                "description": "Blended MS/HS VEX V5 Robotics Competition",
                "location": "Madison, SD",
                "url": "",
            },
            {
                "eventId": "spearfish-2025",
                "name": "Spartan Robot Rally",
                "imagePath": "images/push-back/push-back-1.png",
                "date": "Feb 7, 2025",
                "description": "Blended MS/HS VEX V5 Robotics Competition",
                "location": "Spearfish Middle School",
                url: ''
            },
        ];
        // return this.data.events.filter(e => e.date);
    }

    getAllVexClubs = () => {
        return this.data.clubs.map(c => {
            return {
                ...c,
                teams: c.teams.filter(t => t.teamType === 'vex').map(t => {
                    return {
                        ...t,
                        name: t.teamNumber,
                        url: `https://www.robotevents.com/teams/V5RC/${t.teamNumber}`
                    }
                })
            }
        })
            .filter(c => c.teams.length > 0)
            .map(c => {
                if (c.clubId === "spartan-robotics"){
                    return {
                        ...c,
                        clubLink: 'https://spartan-robotics.clubs.robohq.org/'
                    };
                }
                return c;
            });
    }
    getAllFRCClubs = () => {
        return this.data.clubs.map(c => {
            return {
                ...c,
                teams: c.teams.filter(t => t.teamType === 'frc').map(t => {
                    return {
                        ...t,
                        name: t.teamNumber,
                        url: `https://frc-events.firstinspires.org/team/${t.teamNumber}`
                    }
                })
            }
        })
            .filter(c => c.teams.length > 0);
    }
    getAllFTCClubs = () => {
        return this.data.clubs.map(c => {
            return {
                ...c,
                teams: c.teams.filter(t => t.teamType === 'ftc').map(t => {
                    return {
                        ...t,
                        name: t.teamNumber,
                        url: `https://ftc-events.firstinspires.org/2024/team/${t.teamNumber}`
                    }
                })
            }
        })
            .filter(c => c.teams.length > 0);
    }

    getAllVexUClubs = () => {
        return this.data.clubs.map(c => {
            return {
                ...c,
                teams: c.teams.filter(t => t.teamType === 'vex-u').map(t => {
                    return {
                        ...t,
                        name: t.teamNumber,
                        url: `https://www.robotevents.com/teams/VEXU/${t.teamNumber}`
                    }
                })
            }
        })
            .filter(c => c.teams.length > 0);
    }

    private shuffledOtherCampaigns?: IFundingCampaign[]
    getShuffledOtherCampaigns = (): IFundingCampaign[] => {
        if (!this.shuffledOtherCampaigns) {
            this.shuffledOtherCampaigns = ([] as IFundingCampaign[])
                .concat([
                    {
                        campaignId: 'https://givebutter.com/85T8ya',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/YQRlaL9DddnUCrzjPsHuWo7jEFll3Isl4fVWJhBO.png',
                        title: 'Push Back Beef Raffle',
                        url: 'https://givebutter.com/85T8ya',
                    },
                    {
                        campaignId: 'https://givebutter.com/SX4wbx',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/5nJktW1Ruahg9R2oJpPfpKYermLJPFkvQUL0r3eS.jpg',
                        title: 'Black Hills Robo Rally (Sep 13)',
                        url: 'https://givebutter.com/SX4wbx',
                    },
                    {
                        campaignId: 'https://givebutter.com/Ey471S',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/Rjn7PVbjePReshuryNcJKw0nQe0tLZ7K0acV7srO.jpg',
                        title: 'Spearfish Push Back Season',
                        url: 'https://givebutter.com/Ey471S',
                        goalWidgetId: 'gJQD8L'
                    },
                    {
                        campaignId: 'https://givebutter.com/iYCLAT',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/LTdFdL9CDfmvDUBqN60fwA48ohoW3R98JRCDsJXR.jpg',
                        title: 'Douglas Push Back Season',
                        url: 'https://givebutter.com/iYCLAT',
                        goalWidgetId: 'LZQJqj'
                    },
                    {
                        campaignId: 'https://givebutter.com/X17zGP',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/qEjksfe856q3RowFm5Tv6APCBSeBLWDodS0RGZBy.jpg',
                        title: 'Tournament Sponsors',
                        url: 'https://givebutter.com/X17zGP',
                        goalWidgetId: 'g8Z6Aj'
                    },
                    {
                        campaignId: 'https://givebutter.com/qiiniF',
                        coverImagePath: 'https://givebutter.s3.amazonaws.com/media/ca2Q64fBKQKb11lWBKvjg5TLpolA8wjBIj8f4Rwz.jpg',
                        title: 'Fund New Programs',
                        url: 'https://givebutter.com/qiiniF',
                        goalWidgetId: 'prmAQg'
                    }


                ])
                .map(c => ({
                    ...c,
                    random: Math.random()
                }))

                .sort((l, r) => l.random - r.random)
                .map(({ random, ...campaign }) => campaign);
        }
        return this.shuffledOtherCampaigns;
    }

    private shuffledSponsors?: ISponsor[];
    getShuffledSponsors = (): ISponsor[] => {
        if (!this.shuffledSponsors) {
            this.shuffledSponsors = [
                ...this.data.sponsors,
                {
                    sponsorId: 'pioneer-bank',
                    logoPath: 'https://www.pioneerbankandtrust.com/wp-content/uploads/2023/06/pioneerbank-300x101.png',
                    clubs: ['spartan-robotics']
                },
                {
                    "sponsorId": "meyer-dana",
                    "clubs": [
                        "spartan-robotics"
                    ],
                    "logoPath": "./images/sponsors/meyer-dana.png"
                }
            ]
                .map(c => ({
                    ...c,
                    random: Math.random()
                }))
                .sort((l, r) => l.random - r.random)
                .map(({ random, ...sponsor }) => sponsor);
        }
        return this.shuffledSponsors;
    }

    private shuffledTestimonials?: (ITestimonial & { club: IWebsiteClub })[];
    getShuffledTestimonials = (): (ITestimonial & { club: IWebsiteClub })[] => {
        if (!this.shuffledTestimonials) {
            this.shuffledTestimonials = this.data.testimonials
                .concat([
                    {
                        clubId: 'spartan-robotics',
                        studentInfo: {
                            grade: '8th',
                            name: 'Dane'
                        },
                        testimonial: 'I am glad I did robotics this year because it helped me develop my teamwork, communication, coding, and building skills in a very creative, challenging and fun environment',
                        testimonialId: 'dane-8th'
                    },
                     {
                        clubId: 'spartan-robotics',
                        studentInfo: {
                            grade: 'parent',
                            name: 'Janet'
                        },
                        testimonial: 'Spartan Robotics has for provided an inspiring and fun opportunity for my son to expand his innate mechanical engineering skills. Robotics has also challenged him to develop the invaluable life skill of communicating clearly and confidently, both verbally and in writing, with and for peers and adult judges. It is a fantastic program!',
                        testimonialId: 'dane-8th-parent'
                    }
                ])
                .filter(t => t.clubId && t.studentInfo)
                .map(t => {
                    return {
                        ...t,
                        club: this.getClub(t.clubId!)
                    };
                })
                .map(t => ({
                    ...t,
                    random: Math.random()
                }))
                .sort((l, r) => l.random - r.random)
                .map(({ random, ...testimonial }) => testimonial as (ITestimonial & { club: IWebsiteClub }));
        }
        return this.shuffledTestimonials;
    }

    getClub = (clubId: string): IWebsiteClub => {
        const club = this.data.clubs.find(c => c.clubId === clubId);
        if (!club) {
            throw new Error(`club ${clubId} not found`);
        }
        return club;
    }

    private shuffledVolunteers?: VolunteerForUI[];
    getShuffledVolunteers = (): VolunteerForUI[] => {
        if (!this.shuffledVolunteers) {
            this.shuffledVolunteers = this.data.volunteers
                .filter(v => v.imagePath)
                .filter(v => ![
                    'vlG6KhOJFeU4z1jaqgcik', // katie
                    'iCsf143_xVwDaajZd6sKe', // cameron
                    '_uKInniaFmWarCrFpnTt9', // sam
                    'PUVV4Fp3iYvt6Bw9jCVsf', // Jason
                ].includes(v.volunteerId))
                .filter(v => !v.name.startsWith('Kiley'))
                .concat([
                    {
                        volunteerId: 'michael',
                        clubIds: ['douglas-robotics'],
                        imagePath: 'https://3.files.edl.io/f060/24/11/05/180539-cf26121e-a629-4529-b3ec-7abeb9a0642d.jpg',
                        name: 'Michael Curran',
                        titles: ['HS Coach', 'Computer Teacher']
                    }
                ])
                .map(v => ({
                    ...v,
                    random: Math.random()
                }))
                .sort((l, r) => l.random - r.random)
                .map(({ random, ...volunteer }) => volunteer as VolunteerForUI);
        }

        const missingVolunteers = this.getMissingVolunteers(this.shuffledVolunteers);

        return this.shuffledVolunteers.map(v => {
            if (!v.volunteerId) {
                return v;
            }

            for (const club of this.clubsState.getAllClubStates()) {
                const volunteerFromClubsState = club.getVolunteers().find(cv => v.volunteerId === cv.volunteerId);
                if (volunteerFromClubsState) {
                    return this.mapApiVolunteerToVolunteerForUI(volunteerFromClubsState);
                }
            }

            return v;
        })
            .map(v => ({
                ...v,
                imagePath: v.imagePath || 'https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI='
            }))
            .filter(v => {
                const clubIdsIHaveStateFor = this.clubsState.getAllClubStates().map(c => c.getClub().clubId);
                const matchingClubId = clubIdsIHaveStateFor.find(clubId => v.clubIds.includes(clubId));
                if (!matchingClubId) {
                    // I don't have more authoritive state
                    return true;
                }

                // filter out those that no longer exist in the local club state
                return this.clubsState.getClubState(matchingClubId).getVolunteers().some(cv => cv.volunteerId === v.volunteerId);
            })
            .concat(missingVolunteers);
    }

    private getMissingVolunteers = (volunteers: VolunteerForUI[]): VolunteerForUI[] => {
        const volunteerIds = volunteers.map(v => v.volunteerId);

        const missingVolunteers: IVolunteerMediaType[] = [];
        for (const club of this.clubsState.getAllClubStates()) {
            for (const missing of club.getVolunteers().filter(v => !volunteerIds.includes(v.volunteerId))) {
                missingVolunteers.push(missing);
                volunteerIds.push(missing.volunteerId);
            }
        }

        return missingVolunteers.map(this.mapApiVolunteerToVolunteerForUI);
    }

    private mapApiVolunteerToVolunteerForUI = (volunteer: IVolunteerMediaType): VolunteerForUI => {
        return {
            volunteerId: volunteer.volunteerId,
            clubIds: volunteer.clubIds,
            name: volunteer.name,
            imagePath: volunteer.imagePath,
            titles: volunteer.titles
        }
    }

    getCompetingAndFutureClubs = (): ICompetingOrFutureClub[] => {
        return this.data.clubs
            .filter(c => !c.teams.some(t => t.teamType === 'vex-u'))
            .map(this.mapClubToViewModel);
    }

    private mapClubToViewModel = (club: IWebsiteClub): ICompetingOrFutureClub => {
        // NOTE: DataModelV2 is used before ClubsState has completed init for fast  UX
        const stateClub = this.clubsState.maybeGetClub(club.clubId);
        if (stateClub) {
            club = stateClub;
        }

        const hasAnyTeams = club.teams.length > 0;
        return {
            ...club,
            health: {
                ...club.health,
                volunteerStatus: club.health.volunteerStatus || 'danger',
                fundingStatus: club.health.fundingStatus || 'danger',
                labStatus: club.health.labStatus || 'danger'
            },
            status: hasAnyTeams ? 'status-competing' : 'status-forming'
        }
    }

    getFundingCampaignForClub = (clubId: string): IFundingCampaign | undefined => {
        // TODO: better to flag one as primary then just pick the first one
        return this.data.campaigns.find(c => c.clubId === clubId);
    }

    canAdminister = (clubId: string) => {
        const actions = (this.clubsState.maybeGetClub(clubId) as any)?.links.self.actions || [];
        return actions.includes('PUT');
    }
}
